import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';

const Terms = () => {
  const { language } = useLanguage();
  const isEs = language === 'es';

  return (
    <div className="min-h-screen bg-zinc-950">
      <div className="max-w-2xl mx-auto px-6 py-12">
        <Link to="/" className="inline-block text-zinc-500 hover:text-white text-sm mb-8 transition-colors">
          ← {isEs ? 'Volver a Inker' : 'Back to Inker'}
        </Link>

        <h1 className="text-2xl font-bold text-white mb-6">
          {isEs ? 'Términos de Uso' : 'Terms of Use'}
        </h1>

        <p className="text-zinc-400 mb-8">
          {isEs
            ? 'Al usar Inker aceptas estos términos. Por favor léelos con atención.'
            : 'By using Inker you agree to these terms. Please read them carefully.'}
        </p>

        <h2 className="text-lg font-semibold text-white mt-8 mb-3">
          {isEs ? 'Aceptación' : 'Acceptance'}
        </h2>
        <p className="text-zinc-400 mb-6">
          {isEs
            ? 'Usar la app constituye la aceptación de estos términos. Si no estás de acuerdo, no uses el servicio.'
            : 'Using the app constitutes acceptance of these terms. If you do not agree, do not use the service.'}
        </p>

        <h2 className="text-lg font-semibold text-white mt-8 mb-3">
          {isEs ? 'Conducta del usuario' : 'User conduct'}
        </h2>
        <p className="text-zinc-400 mb-6">
          {isEs
            ? 'Te comprometes a usar la app de forma responsable, respetar a otros usuarios y no publicar contenido ilegal u ofensivo.'
            : 'You agree to use the app responsibly, respect other users and not publish illegal or offensive content.'}
        </p>

        <h2 className="text-lg font-semibold text-white mt-8 mb-3">
          {isEs ? 'Contacto' : 'Contact'}
        </h2>
        <p className="text-zinc-400">
          {isEs
            ? 'Para preguntas sobre estos términos, contáctanos en '
            : 'For questions about these terms, contact us at '}
          <a href="mailto:support@inker.app" className="text-white underline hover:no-underline">
            support@inker.app
          </a>
        </p>

        <p className="text-zinc-600 text-sm mt-12">
          {isEs ? 'Última actualización: Marzo 2025' : 'Last updated: March 2025'}
        </p>
      </div>
    </div>
  );
};

export default Terms;
